import OnboardingInviteTeam from './OnboardingInviteTeam'

export default OnboardingInviteTeam
